import { InjectionToken } from '@angular/core';
import { AuthContextType, RemoteConfigModel } from '@libs/shared/models';
import { Observable } from 'rxjs';

/**
 * App
 */

export type ApplicationIdType = 'CEP' | 'DCP-PLAYBOOK' | 'LL-SERVICES' | 'LL-COM' | 'LL-SHOP';

export interface AppEnvironmentModel {
  readonly baseHref: string;
  readonly applicationId?: ApplicationIdType;
  readonly context?: AuthContextType;
  /** @deprecated CEP should use CMS app config settings.gtmId instead. */
  readonly gtmID?: string;
}

/**
 * CMS
 */
export interface CmsEnvironmentModel {
  gtmID: string;
}

/**
 * Environment
 */
export type EnvironmentType = 'local' | 'dev' | 'stage' | 'prod';

export interface EnvironmentModel {
  readonly type: EnvironmentType;
  readonly production: boolean;
  readonly app?: AppEnvironmentModel;
  readonly cms?: CmsEnvironmentModel;
  readonly bff?: RemoteConfigModel;
  readonly liveUpdateUrl: string;
  readonly appVersion: string;
  readonly msalConfig: MsalConfigModel;
  readonly msalLekkerlandDirectoryUserConfig: MsalConfigModel;
  readonly consentConfig: ConsentConfigModel | undefined;
  readonly links: LinkConfigModel;
  readonly grafanaFaroConfig: GrafanaFaroConfigModel;
}

type EnvironmentKey = keyof EnvironmentModel;

export type EnvironmentServiceModel = {
  readonly [key in EnvironmentKey]-?: () => EnvironmentModel[key] | Observable<EnvironmentModel[key]>;
};

export interface MsalConfigModel {
  clientId: string;
  tenantId: string;
  redirectUri: string;
  authorityHostname: string;
  androidHash: string;
  signInPolicy: string;
  signUpPolicy: string;
  resetPasswordPolicy: string;
  appId: string;
  iosAppStoreId: string;
}

export interface LinkConfigModel {
  deliveryTracking: string;
  /** Public application URL, preserved when native platforms clear app.baseHref. */
  appUrl: string;
  whatsAppNewsletter: string;
  playStoreUrl: string;
}

export interface ConsentConfigModel {
  settingId: string;
  version: string | undefined;
}

export interface GrafanaFaroConfigModel {
  url: string;
  secret: string;
}

export const ENVIRONMENT: InjectionToken<EnvironmentModel> =
  new InjectionToken<EnvironmentModel>('environment');
